export default __webpack_public_path__ + "static/media/A0003.5fc76c24.png";